function openMenus(menu){
	if(menu){
		const dropDownTrigger = menu.querySelector('.trigger-button');
		dropDownTrigger.addEventListener('click', ()=>{
			menu.classList.contains('active') ? 
			menu.classList.remove('active') :
			menu.classList.add('active');
		});
	}
}
document.addEventListener('DOMContentLoaded', ()=>{
	const buyButtons = document.querySelectorAll('.reorder-btn');
	if(buyButtons){
		buyButtons.forEach(element => {
			// console.log(element);
		});
	}

	const companyDropDown = document.querySelector('.header-company-dropdown');
	const userDropDown = document.querySelector('.header-b2b-user-dropdown');
	openMenus(companyDropDown);
	openMenus(userDropDown);
});